import "./KCopyButton.scss";
import Themeable from "vuetify/lib/mixins/themeable";
import {
	VBtn,
	VIcon,
	VRow
} from "vuetify/lib";
import { copyToClipboard } from "kinnect-helpers";

export default {
	name: "KCopyButton",

	extends: VBtn,

	mixins: [ Themeable ],

	props: {
		copiedColor: {
			default: "success",
			type: String
		},
		showValue: Boolean,
		value: [ Number, String ]
	},

	data: () => ( {
		copied: false
	} ),

	computed: {
		propsToPass() {
			const {
				copiedColor,
				showValue,
				...propsToPass
			} = this.$props;

			return propsToPass;
		},

		dynamicColor() {
			return this.copied ? this.copiedColor : this.color;
		},

		classes() {
			return {
				"k-copy-button": true,
				"k-copy-button--show-value": this.showValue,
				...this.themeClasses
			};
		},

		genButton() {
			return <VBtn
				attrs={this.propsToPass}
				class="k-copy-button__btn"
				color={this.dynamicColor}
				depressed={this.depressed || this.showValue}
				disabled={!this.value}
				on={{ ...this.$listeners }}
				onClick={() => {
					copyToClipboard( this.value );
					this.copied = true;
				}}
			>
				<VIcon
					large={this.large}
					left
					small={this.small}
				>{this.copied ? "done" : "content_copy"}</VIcon>

				Copy
			</VBtn>;
		}
	},

	watch: {
		copied( val ) {
			if ( val ) {
				setTimeout( () => this.copied = false, 5000 );
			}
		},

		value() {
			this.copied = false;
		}
	},

	render() {
		if ( this.showValue ) {
			return <VRow class={this.classes} nowrap>
				<span class="k-copy-button__text">
					{this.value}
				</span>

				{this.genButton}
			</VRow>;
		}

		return <div class={this.classes}>{this.genButton}</div>;
	}
};
